import React from 'react';
import ImportNewsHome from './ImportNewsHome';

/**
 * RoleDashboard — the post-login landing.
 *
 * task-n1e23erl53 (CEO 09-12, orchestrator ruling A "Home for every role"): every role lands on ImportNewsHome —
 * the latest imports the user has access to and the products skipped or blocked, by reason, with the
 * category-research gap first-class. The content manager's workspace stays reachable at
 * /dashboard/content-manager (linked from the Home page for that role); the generic quick actions are folded under
 * the news.
 */
export default function RoleDashboard() {
  return <ImportNewsHome />;
}
